module.exports = __webpack_public_path__ + "Wireframes3.png?a1864c1865afa56ff7376b072f9cc51a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Wireframes3.png
// module id = 117
// module chunks = 0